import axios from '../config/axiosConfig';

const API_URL = '/mitre/';

// Get all MITRE ATT&CK techniques
const getTechniques = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Get techniques by tactic
const getTechniquesByTactic = async (tactic) => {
  const response = await axios.get(API_URL + 'tactic/' + tactic);
  return response.data;
};

// Get single technique
const getTechnique = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

// Get techniques used by project
const getTechniquesByProject = async (projectId) => {
  const response = await axios.get(API_URL + 'project/' + projectId);
  return response.data;
};

// Get techniques organized as tree by tactic
const getTechniqueTree = async () => {
  const response = await axios.get(API_URL + 'tree/by-tactic');
  return response.data;
};

const mitreService = {
  getTechniques,
  getTechniquesByTactic,
  getTechnique,
  getTechniquesByProject,
  getTechniqueTree,
};

export default mitreService;